const importMetaEnv = import.meta.env;
export default function env(key: keyof ImportMeta['env'], required = true) {
    if (!required || importMetaEnv[key]) {
        return importMetaEnv[key] as string;
    } else {
        throw new Error(`${key} not defined in environment`);
    }

}
